import { FC } from 'react';
import { Link } from 'react-router-dom';

import useFeatureValidation from '../../utils/useFeatureValidation';

interface IWsLink {
  feature?: string;
  authorities?: string[];
  to: string;
  onFailure?: string;
}

const WsLink: FC<IWsLink> = ({ children, feature, authorities, to, onFailure }) => {
  const isFeatureAllowed = useFeatureValidation(feature, authorities);

  return (
    <>
      {isFeatureAllowed === null || isFeatureAllowed ? (
        <Link to={to}>{children}</Link>
      ) : (
        <Link to={onFailure ? onFailure : '/'}>{children}</Link>
      )}
    </>
  );
};
export default WsLink;
